package one.healthium.domain.user.models

import kotlinx.serialization.Serializable
import one.healthium.domain.common.FoodUnit
import kotlin.time.Instant

@Serializable
data class FoodLogModel(
    val id: String? = null, // was added later so it's nullable
    val date: Instant,
    val food: List<FoodItemModel>,
) {
    val totalCalories = food.sumOf { food -> food.calories.toDouble() }.toFloat()
}

@Serializable
data class FoodItemModel(
    val id: String? = null, // was added later so it's nullable
    val date: Instant,
    val amount: Float,
    val isLiquid: Boolean,
    val name: String,
    val calories: Float,
    val fat: Float,
    val carbohydrates: Float,
    val fiber: Float,
    val protein: Float,
    val tablespoon: Float?,
    val cups: Float?,
    val pieces: Float?,
    val portion: Float?,
    val unit: FoodUnit?,
)
